import { List, Typography } from "antd";
import React from "react";

interface Props {
  log: string[];
  onCancel?: () => void;
}
const SyncLog = (props: Props) => {
  const { log } = props;

  const renderLine = (line: string) => (
    <List.Item>
      <Typography.Text code>{line}</Typography.Text>
    </List.Item>
  );
  return (
    <List itemLayout="horizontal" dataSource={log} renderItem={renderLine} />
  );
};

export default SyncLog;
